import React, { useCallback } from 'react';
import { Button, Col, Stack, Text } from 'rsuite';

interface PaymentMethodButtonProps {
  icon: string | string[];
  isActive?: boolean;
  name: string;
  onClick: () => void;
}

export const PaymentMethodButton = ({
  icon,
  isActive,
  name,
  onClick,
}: PaymentMethodButtonProps) => {
  const renderIcons = useCallback(() => {
    const iconArr = typeof icon === 'string' ? [icon] : icon;
    return iconArr.map((i) => {
      return (
        <img
          alt={`${name}-${i}-icon`}
          height="12px"
          key={i}
          src={i}
        />
      );
    });
  }, [icon, name]);

  return (
    <Col
      xs={24}
      md={12}
      className="mb-8"
    >
      <Button
        onClick={onClick}
        className={`payment-type-button ${isActive ? 'payment-type-button-active' : ''}`}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          style={{ width: '100%' }}
        >
          <div style={{ display: 'flex', margin: '6px 0 10px', gap: '5px' }}>
            {renderIcons()}
          </div>
          <Text className="text-small">{name}</Text>
        </Stack>
      </Button>
    </Col>
  );
};
